export default __webpack_public_path__ + "images/22_2_image.jpg";